module.exports = "/images/approve_cancel-black.svg?a6644d74f4dc036894db3a9478eb347a";